import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import { FC, useEffect, useState } from "react";
import { AgentExtraData } from "../../../Shared-ui/Types/PlayGround";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImportContactsOutlinedIcon from "@mui/icons-material/ImportContactsOutlined";

interface MycomponentProps {
  data: any;
  incomingTextColor?: any;
  setShowCitations: React.Dispatch<React.SetStateAction<boolean>>;
}

const AgentPlaygroundReferences: FC<MycomponentProps> = (props) => {
  const [references, setReferences] = useState<any[]>([]);
  const [expandedIndexes, setExpandedIndexes] = useState<Set<number>>(
    new Set()
  );
  const [showAllRef, setShowAllRef] = useState<boolean>(false);
  const [showQustions, setShowQuestions] = useState<boolean>(true);

  useEffect(() => {
    const refArray: any = [];
    if (!Array.isArray(props.data) && props.data?.references) {
      props.data?.references.forEach((ref: any) => {
        ref.references?.map((item: any) => {
          refArray.push(item);
        });
      });
      if (refArray.length > 0) {
        setReferences(refArray);
        props.setShowCitations(true);
      }
    } else {
      if (Array.isArray(props.data) && props.data?.length > 0) {
        // props.data?.forEach((agentRes: any) => {
        //   if (agentRes?.metadata?.extra_data?.references) {
        //     agentRes?.metadata?.extra_data?.references.forEach((ref: any) => {
        //       ref.references?.map((item: any) => {
        //         refArray.push(item);
        //       });
        //     });
        //   }
        // });
        if (props.data?.length > 0) {
          setReferences(props.data);
          props.setShowCitations(true);
        }
      }
    }
  }, [props.data]);

  const hasReferences = references.length > 0;
  if (!hasReferences) {
    return null;
  }

  const toggleExpand = (index: number) => {
    setExpandedIndexes((prev) => {
      const newSet = new Set(prev);
      newSet.has(index) ? newSet.delete(index) : newSet.add(index);
      return newSet;
    });
  };

  const getPreview = (reference: any, wordLimit: number = 1) => {
    if (reference.name && reference.meta_data.location_info) {
      return `${reference?.name} - ${reference?.meta_data?.location_info}`;
    } else {
      return `something went wrong `;
    }
  };

  const ShowAllReferences = () => {
    setShowAllRef((prev) => !prev);
  };

  return (
    <>
      {/* <Divider sx={{ mt: 1 }} /> */}
      <Box
        sx={{
          mt: 1,
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          p: 2,
        }}
      >
        <Button
          variant="text"
          size="small"
          onClick={ShowAllReferences}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            textTransform: "capitalize",
            p: 0,
            lineHeight: 1,
            color: props.incomingTextColor
          }}
        >
          <ImportContactsOutlinedIcon sx={{ fontSize: 20 }} />
          {!showAllRef ? `Show Citations` : `Hide Citations`}
        </Button>

        {showAllRef && (
          <Box
            sx={{
              mt: 1,
              padding: "0 26px",
            }}
          >
            {references.map((reference, index) => (
              <Accordion
                key={index}
                sx={{
                  boxShadow: "none",
                  background: "none",
                  borderBottom: "1px solid rgba(24, 24, 27, .1)",
                  color: "inherit",
                  "&:before": {
                    display: "none",
                  },
                  "&:last-of-type": {
                    borderBottom: "none",
                  },
                  "&.Mui-expanded": {
                    margin: "16px 0px 0 0",
                  },
                  "&:hover": {
                    //backgroundColor: "#a02d2dff",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: props.incomingTextColor }} />}
                  aria-controls={`panel-content-${index}`}
                  id={`panel-header-${index}`}
                  sx={{
                    padding: 0,
                    "&.Mui-expanded": {
                      margin: 0,
                      minHeight: "auto",
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                      margin: 0,
                    },
                    "& .MuiTypography-root": {
                      fontWeight: "600 !important", // force normal weight
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    //color="text.secondary"
                    sx={{ wordBreak: "break-word", color: props.incomingTextColor }}
                  >
                    {getPreview(reference)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    padding: 0,
                    marginBottom: 2,
                  }}
                >
                  <Typography
                    variant="body2"
                    //color="text.secondary"
                    sx={{ wordBreak: "break-word", color: props.incomingTextColor }}
                  >
                    {reference.content}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default AgentPlaygroundReferences;
